import testProgressAdminApi from "../../api/dte/testProgressAdminApi";

const TestProgressAdminService = {

  /**
   * Obtener todos los registros de progreso.
   */
  getAll: async () => {
    try {
      const response = await testProgressAdminApi.fetchAll();
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Obtener el detalle de un registro específico.
   */
  getById: async (id: number) => {
    try {
      const response = await testProgressAdminApi.fetchById(id);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Actualizar el progreso de forma manual.
   */
  update: async (id: number, payload: { completedCount?: number; completed?: boolean }) => {
    try {
      const response = await testProgressAdminApi.modify(id, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};

export default TestProgressAdminService;
